import { object } from "@/common/object.util";
import ApiAdmin from "@/services/apiAdmin.service";
import { FETCH_ALL, FETCH, SAVE } from "@/store/actions/actions.type";
import {
  FETCH_ALL_START,
  SET_ALL,
  FETCH_ALL_END,
  FETCH_START,
  FETCH_END,
  SAVE_START,
  SAVE_END,
  SET
} from "@/store/mutations/mutations.type";

const defaults = Object.freeze({
  royaltie: {
    id: undefined,
    nome: null,
    plano: null,
    valor_cobranca: null,
    porcentagem: null
  },
  royalties: {
    current_page: 1,
    per_page: 10,
    data: []
  }
});

const state = {
  royaltie: object.clone(defaults.royaltie),
  royalties: object.clone(defaults.royalties),
  isFetchingRoyalties: false,
  isFetchingRoyaltie: false,
  isSavingRoyaltie: false
};

const getters = {
  royaltie(state) {
    return state.royaltie;
  },
  royalties(state) {
    return state.royalties;
  },
  isFetchingRoyalties(state) {
    return state.isFetchingRoyalties;
  },
  isFetchingRoyaltie(state) {
    return state.isFetchingRoyaltie;
  },
  isSavingRoyaltie(state) {
    return state.isSavingRoyaltie;
  }
};

const actions = {
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);

      ApiAdmin.query("royalties/list", params)
        .then(response => {
          context.commit(SET_ALL, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  },
  [FETCH](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SET, object.clone(defaults.royaltie));

      if (!params) {
        resolve();
        return;
      }

      context.commit(FETCH_START);

      ApiAdmin.get("royalties/get", params)
        .then(response => {
          if (response.data.id) {
            context.commit(SET, response.data);
            resolve();
          } else {
            reject({ notFound: true });
          }
        })
        .catch(e => {
          console.log(e);
          reject(false);
        })
        .finally(() => {
          context.commit(FETCH_END);
        });
    });
  },
  [SAVE](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SAVE_START);

      if (params.id) {
        ApiAdmin.put("royalties/update", params.id, params)
          .then(response => {
            context.commit(SET, response.data);
            resolve();
          })
          .catch(e => {
            console.log(e);
            reject(e.response);
          })
          .finally(() => {
            context.commit(SAVE_END);
          });
      } else {
        ApiAdmin.post("royalties/add", params)
          .then(response => {
            context.commit(SET, response.data);
            resolve();
          })
          .catch(e => {
            console.log(e);
            reject(e.response);
          })
          .finally(() => {
            context.commit(SAVE_END);
          });
      }
    });
  }
};

const mutations = {
  [FETCH_ALL_START](state) {
    state.isFetchingRoyalties = true;
  },
  [SET_ALL](state, royalties) {
    state.royalties = royalties;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingRoyalties = false;
  },
  [FETCH_START](state) {
    state.isFetchingRoyaltie = true;
  },
  [FETCH_END](state) {
    state.isFetchingRoyaltie = false;
  },
  [SET](state, royaltie) {
    state.royaltie = royaltie;
  },
  [SAVE_START](state) {
    state.isSavingRoyaltie = true;
  },
  [SAVE_END](state) {
    state.isSavingRoyaltie = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
